import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../utils/BodyWrap";
import ErrorText from "../utils/error-success/ErrorText";
import GeneralLoader from "../GeneralLoader";
import LinkedTitle from "../utils/titles/LinkedTitle";
import NewsContent from "./NewsContent";

// State
import { getTranslations } from "../../store/actions/translations";
import { getNewsItemByPermalink, clearNewsItem } from "../../store/actions/newsItem";

class NewsStory extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];

		// Translations
		const translationSections = ["news_listing"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		// Other stuff the page needs
		const permalink = props.params ? props.params.permalink : props.match.params.permalink;
		if (store !== null) {
			promises.push(getNewsItemByPermalink(permalink));
		} else {
			promises.push(props.getNewsItemByPermalink(permalink));
		}

		return promises;
	}

	// ===================================
	//  LIFE CYCLE
	// ===================================
	componentDidMount() {
		if (!this.props.news) {
			NewsStory.initialAction(null, this.props);
		}
	}

	componentWillUnmount() {
		this.props.clearNewsItem();
	}

	// ===================================
	//  RENDER
	// ===================================
	render() {
		const { translationsLoading, translations, isLoading, error, news } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!news) {
			if (title !== "") title += " | ";
			title += news.title;
		} else if (!!translations.sections.news_listing) {
			if (title !== "") title += " | ";
			title += translations.sections.news_listing.title_bar_title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						{translationsLoading ? (
							<GeneralLoader />
						) : (
								<React.Fragment>
									<LinkedTitle
										link={{
											href: "/news",
											title: translations.sections.news_listing.title_bar_link
										}}
									>
										{translations.sections.news_listing.title_bar_title}
									</LinkedTitle>
									<div className="section-content">
										{!!isLoading && <GeneralLoader />}
										{!!error && <ErrorText errors={error} />}
										{!!news && <NewsContent news={news} />}
									</div>
								</React.Fragment>
							)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		isLoading: state.newsItem.isLoading,
		error: state.newsItem.error === undefined ? null : state.newsItem.error,
		news: state.newsItem.news
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getNewsItemByPermalink, clearNewsItem }
)(NewsStory);



// WEBPACK FOOTER //
// ./src/components/news/NewsStory.js